import options from './send-mail.component';

export default {
    selector: 'dtAlertsActionsSendMail',
    options
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/send-mail/index.js